export const paymentScreens = [
    require('@assets/img/screenshots/1.png'),
    require('@assets/img/screenshots/2.png'),
    require('@assets/img/screenshots/3.png'),
    require('@assets/img/screenshots/4.png'),
    require('@assets/img/screenshots/5.jpeg'),
];
